import {CookieStorage} from '@infra/api/CookieStorage';
import {IAuthStorage, TOKEN_KEY} from './types';

export const AuthStorage: IAuthStorage = {
  set: async newToken => CookieStorage.set(TOKEN_KEY, newToken, {expires: 365}),
  get: async () => CookieStorage.get(TOKEN_KEY),
  remove: async () => CookieStorage.remove(TOKEN_KEY),
};
